/* eslint-disable @typescript-eslint/no-explicit-any */
import { notification } from 'antd'
import guildApi from 'apis/guildApi'
import ModalManagerMember from 'features/Guild/components/ModalManagerMember'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import Button from 'shared/Button'
import { handleAsyncRequest } from 'utils/helper'
import DemoteMemberContainer from './styled'

const DemoteMember = ({ downgradeSuccess }: any) => {
  const [showModal, setShowModal] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [api, contextHolder] = notification.useNotification()

  const { guild_id, user_id } = useParams()

  const openNotification = (message: string, description: string) => {
    notification.config({
      duration: 4
    })

    api.info({
      message,
      description,
      placement: 'bottomRight',
      className: message === 'ERROR' ? 'ant-custom-error' : 'ant-custom-success'
    })
  }

  const _handleToggleModal = () => {
    setShowModal(!showModal)
  }

  const _handleDowngrade = async () => {
    setIsLoading(true)

    const [error, result]: any = await handleAsyncRequest(guildApi.putRoleUserGuild(Number(guild_id), Number(user_id), { role: 'MEMBER' }));
    setIsLoading(false);
    if (error) {
      openNotification('ERROR', error.message || error.errors[0]?.message)
    }

    if (result) {
      _handleToggleModal()
      downgradeSuccess('MEMBER')
    }
  }

  return (
    <DemoteMemberContainer>
      {contextHolder}
      <Button
        buttonName='Demote to member'
        onClickButton={_handleToggleModal}
        type="btnCancel"
        height={42}
        width={170}
      />
      {showModal && (
        <ModalManagerMember
          title='Downgrade guild role'
          message={<p>Would you like to downgrade this manager to a <br /> member position?</p>}
          onClose={_handleToggleModal}
          onConfirm={_handleDowngrade}
          loading={isLoading}
        />
      )}
    </DemoteMemberContainer>
  )
}

export default DemoteMember
